import { Router } from '@angular/router';
import { LanguageService } from '../../../core/language/language.service';
import * as i0 from "@angular/core";
import * as i1 from "../../../core/language/language.service";
import * as i2 from "@angular/router";
var UserProfileService = /** @class */ (function () {
    function UserProfileService(languageService, route) {
        this.languageService = languageService;
        this.route = route;
    }
    UserProfileService.prototype.changeSiteLanguage = function (language) {
        this.languageService.changeSiteLanguage(language);
        this.route.navigate(['/']);
    };
    UserProfileService.ngInjectableDef = i0.defineInjectable({ factory: function UserProfileService_Factory() { return new UserProfileService(i0.inject(i1.LanguageService), i0.inject(i2.Router)); }, token: UserProfileService, providedIn: "root" });
    return UserProfileService;
}());
export { UserProfileService };
